export function delay(milliseconds) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), milliseconds);
  });
}

export function delaySeconds(seconds) {
  return delay(seconds * 1000);
}
